import { ENV } from './env';

const isDev = ENV.isTest;
export const devLog = (key: string, ...info: any) => {
  if (isDev) {
    console.log(`[${key}]`, ...info);
  }
};
